import {
  Divider,
  DividerProps,
  ListItem,
  ListItemText,
  Skeleton,
  Stack,
} from '@mui/material'

interface OwnProps {
  first: boolean
}

type EmploymentItemSkeletonProps = OwnProps

export const EmploymentItemSkeleton = ({
  first,
}: EmploymentItemSkeletonProps) => {
  return (
    <ListItem
      sx={{
        position: 'relative',
        py: 0.125,
        pb: 1,
        px: 3,
        gap: 2.25,
        '&:hover, &:focus': {
          backgroundColor: 'action.hover',
        },
        '&:hover > div, &:focus > div': {
          backgroundColor: 'transparent',
        },
        '&:hover > hr, &:focus > hr': {
          borderColor: 'transparent',
        },
      }}
    >
      {first && <ItemDivider sx={{ top: 0, bottom: 'initial' }} />}
      <Skeleton
        height={40}
        sx={{ mt: 1.25, alignSelf: 'center' }}
        variant="circular"
        width={40}
      />
      <Stack flexGrow={1}>
        <ListItemText
          primary={<Skeleton height={24} variant="text" width="65%" />}
        />
        {first && (
          <Stack
            direction="row"
            gap={1}
            mb={1}
            sx={{ maxWidth: '50vw', minWidth: 106 }}
          >
            <Skeleton
              height={32}
              sx={{ borderRadius: 1 }}
              variant="rectangular"
              width={106}
            />
            <Skeleton
              height={32}
              sx={{ borderRadius: 1 }}
              variant="rectangular"
              width={106}
            />
          </Stack>
        )}
        <ListItemText
          primary={<Skeleton height={18} variant="text" width="25%" />}
        />
      </Stack>
      <ItemDivider />
    </ListItem>
  )
}

const ItemDivider = (props: DividerProps) => (
  <Divider
    {...props}
    sx={Object.assign(
      {
        borderColor: 'divider',
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
      },
      props.sx,
    )}
  />
)
